import { useIsFetching } from 'react-query';
import { createQueryData } from '../helpers/createQueryData';
import { useInvalidate } from '../helpers/useInvalidate';

const endPoint = 'Acceptance/acceptance_view_calendar';

const { useQuery } = createQueryData({ endPoint });

const useAcceptanceViewCalendarQuery = ({
  params: {
    acceptanceId,
    fromDate,
    toDate,
    houseId,
    onAddresses = false,
    onClients = false,
  } = {},
  options,
}) =>
  useQuery({
    params: { acceptanceId, fromDate, toDate, houseId, onAddresses, onClients },
    options: {
      enabled: Boolean(acceptanceId && fromDate && toDate),
      staleTime: 1000 * 10,
      ...options,
    },
  });

const useAcceptanceViewCalendarInvalidate = () => useInvalidate([endPoint]);

const useAcceptanceViewCalendarIsFetching = () => {
  return useIsFetching([endPoint]);
};

export {
  useAcceptanceViewCalendarQuery,
  useAcceptanceViewCalendarInvalidate,
  useAcceptanceViewCalendarIsFetching,
};
